module.exports = __webpack_public_path__ + "img/building.cd7be691.svg";